<!-- <div class="close-btn" (click)="closeSheet($event)">CLOSE <mat-icon>close</mat-icon></div>  -->
<div [ngClass]="arrayObj.is_back==1 ? 'back' : 'lay'">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="bet-slip-header">
        <span class="bet-slip-title">Place Bet</span>
        <div class="close-btn" style="color:#fff" (click)="closeSheet($event)"> <mat-icon>close</mat-icon></div>
    </div>
    <mat-divider>
        <div *ngIf="ring == true"><audio autoplay>
                <source src="assets/ring/Iphone 12 Pro Max - Message Tone.mp3" type="audio/mpeg">
            </audio></div>
    </mat-divider>
    <div fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="start" class="bet-slip-body"
        *ngFor="let back of this.matchModel.tempArray;let index=index">
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">

            <!-- <div  fxLayout="column" fxLayoutAlign="center center">
        <span fxLayoutAlign="center center"><mat-icon>arrow_right_alt</mat-icon>BACK</span>
        <input type="text" class="form-control" placeholder="24" style="width:60%;">
    </div> -->
            <div class="form-list">
                <span fxLayoutAlign="start" class="titleformlay">
                    <mat-icon>arrow_right_alt</mat-icon>
                    <label class="form-label" *ngIf="back?.is_session_fancy=='N'"> <i class="fa fa-arrow-right"></i>
                        {{back?.is_back==1 ? 'Back' :'Lay'}}</label>
                    <label class="form-label" *ngIf="back?.is_session_fancy=='Y'"> <i class="fa fa-arrow-right"></i>
                        {{back?.is_back==1 ? 'Back' :'Lay'}}</label>
                </span>
                <div class="input-group">
                    <input type="text" *ngIf="back?.isManual=='0'" ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/" min="0"
                        step="0.01" [(ngModel)]="back.odds" id="ShowBetPrice"
                        class="calProfitLoss odds-input form-control CommanBtn ng-untouched ng-pristine ng-valid"
                        [ngModelOptions]="{standalone: true}" name="quant[2]" (keyup)="choc(back?.odds)"
                        value="{{back?.odds}}" readonly>
                </div>
            </div>
            <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center center">
                <span fxLayoutAlign="start" class="titleformlay">
                    <mat-icon>stacked_line_chart</mat-icon>STACK
                </span>
                <div class="form-list" fxLayoutGap="10px">
                    <div class="input-group" fxLayout="row" fxLayoutGap="3px">
                        <span class="input-group-text"
                            (click)="back.stake = back.stake - 100;calculateP_lOnStackOnInput(back.stake,back.stake,back.is_back,back);">
                            <mat-icon>remove</mat-icon>
                        </span>
                        <input type="number" min="0" id="stackVal" (focus)="setbtn(index)"
                            (input)="calculateP_lOnStackOnInput(back.stake,back.stake,back.is_back,back);"
                            pattern="[0-9]*" step="1" id="stakeValue" placeholder="0"
                            class="form-control calProfitLoss stake-input f0orm-control CommanBtn ng-untouched ng-pristine ng-valid"
                            [(ngModel)]="(back.stake < 0) ? '0' :back.stake " [ngModelOptions]="{standalone: true}">
                        <span class="input-group-text"
                            (click)="back.stake = back.stake + 100;calculateP_lOnStackOnInput(back.stake,back.stake,back.is_back,back);">
                            <mat-icon>add</mat-icon>
                        </span>
                    </div>
                </div>

            </div>
        </div>
        <div class="betslip-button text-center">
            <div style="display: flex;width: 100%; vertical-align: middle;">
                <!-- <div (click)="scrollLeft()" class="left-scroll-icon">
            <mat-icon>chevron_left</mat-icon>
        </div> -->
                <div #widgetsContent class="scrollmenu" *ngIf="!status">
                    <div class="tab-btn-card" *ngFor="let stake of editstake;let i= index"
                        (click)="calculateP_lOnStack(((back.odds*back.stake)-back.stake),stake,back.is_back,back);">
                        {{stake}}
                    </div>
                    
                    <!-- <div class="tab-editbtn-card"
                        (click)="status=!status">
                        Edit
                    </div> -->
                </div>
                
                <div #widgetsContent class="scrollmenu" *ngIf="status">
                    <input class="tab-btn-card" style="border: 1px solid;" value="{{stake}}" *ngFor="let stake of editstake;let i= index"
                        (change)="onModelChange($event ,i)">
                </div>
                <!-- <div (click)="scrollRight()" class="right-scroll-icon text-right">
            <mat-icon>navigate_next</mat-icon>
        </div> -->
            </div>
        </div>
        <!-- <div class="placebetbtns" *ngIf="!status">
            <button type="button" class="btn btn-outline-primary btn-primary btn-block rounded" style="color: #000 !important; background-color: #fff !important;" [disabled]="betloder"
            (click)="status=!status">Edit</button>
        </div> -->
        <!-- <div class="row list pl-list"> -->
        <div class="placebetbtns" >
            <button type="button" class="btn btn-outline-primary btn-primary btn-block rounded" [disabled]="betloder"
                (click)="saveBet(this.matchModel.tempArray)" *ngIf="arrayObj.is_fancy == 0">Submit</button>
            <button type="button" class="btn btn-outline-primary btn-primary btn-block rounded" [disabled]="betloder"
                (click)="saveFancyBet(this.matchModel.tempArray)" *ngIf="arrayObj.is_fancy == 1">Submit</button>
        </div>
        <!-- <div class="placebetbtns" *ngIf="status">
            <button type="button" class="btn btn-outline-primary btn-primary btn-block rounded" [disabled]="betloder"
            (click)="updatestake()">Update Stake</button>
        </div>
         -->
        <div class="teampl-table-wrap">
            <table class="table ">
                <tr *ngFor="let r of arrayObj?.matchOddsData?.marketBook?.runners;let i=index">
                    <td>{{searchRunner(arrayObj.matchOddsData?.runners,r?.selectionId)}} </td>
                    <td> <span
                            [ngClass]="calProLoss(arrayObj?.matchOddsData?.runners,arrayObj?.matchOddsData?.marketBook,i,arrayObj?.matchOddsData) >0  ? 'profit_v' : 'loss_v'">
                            {{calProLoss(arrayObj?.matchOddsData?.runners,arrayObj?.matchOddsData?.marketBook,i,arrayObj?.matchOddsData)|
                            number : '0.0-2'}}</span> </td>
                    <td *ngIf="back.stake>0"> <span
                            [ngClass]="calProLoss_pre(back.stake,arrayObj?.matchOddsData?.runners,arrayObj?.matchOddsData?.marketBook,i,arrayObj?.matchOddsData) >0  ? 'profit_v' : 'loss_v'">{{calProLoss_pre(back.stake,arrayObj?.matchOddsData?.runners,arrayObj?.matchOddsData?.marketBook,i,arrayObj?.matchOddsData)|
                            number : '0.0-2'}}</span> </td>
                </tr>
            </table>
        </div>



        <div class="form-list" *ngIf="back.is_session_fancy=='N'" fxLayout="row" fxLayoutAlign="space-between center"
            fxLayoutGap="10px">
            <!-- <input type="text" value="0" class="form-control"> -->
            <div class="stack_input_field">
                <label class="form-label">Profit</label>
                <span id="profitData" class="profit" style="color: green;">{{back.stake <= '0' ? '0' : (back.is_back==0
                        ? back.stake :((back.odds*back.stake)-back.stake)=='NaN' ?0:
                        ((back.odds*back.stake)-back.stake).toFixed(2))}}</span>
            </div>

            <!-- <input type="text" value="0" class="form-control"> -->
            <div class="stack_input_field">
                <label class="form-label">Loss</label>
                <span id="profitData" class="profit" style="color: red;">-{{back.stake <= '0' ? '0' :(back.is_back==0 ?
                        ((back.odds*back.stake)-back.stake)=='NaN' ?0: ((back.odds*back.stake)-back.stake).toFixed(2) :
                        back.stake)}}</span>
            </div>
        </div>


        <div class="form-list" *ngIf="back.is_session_fancy=='Y'" fxLayout="row" fxLayoutAlign="space-between center"
            fxLayoutGap="10px">
            <!-- <input type="text" value="0" class="form-control"> -->
            <div class="stack_input_field">
                <label class="form-label">Profit</label>
                <span id="profitData" class="profit" style="color: green;">{{back.is_back ==
                    0 ? back.stake : ((back.size * back.stake)/100).toFixed(2)}}</span>
            </div>

            <!-- <input type="text" value="0" class="form-control"> -->
            <div class="stack_input_field">
                <label class="form-label">Loss</label>
                <span id="profitData" class="profit" style="color: red;">{{back.is_back == 0
                    ? ((back.size * back.stake)/100).toFixed(2) : back.stake}}</span>
            </div>
        </div>
        <!-- </div> -->
        <!-- <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <span>Stake</span>
        <span>9000.00</span>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <span>Profit</span>
        <span>9450.00</span>
    </div> -->

        <div class="cancelclear">
            <div fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="10px">
                <!-- <button fxFlex="30" mat-flat-button color="warn">Cancel</button> -->
                <div class="col p-0">
                    <div class="accept-any" *ngIf="arrayObj.is_fancy == 0 && arrayObj.MatchName=='Match Odds'">
                        <label><input type="checkbox" (click)="acceptAnyBet($event)"> Accept Any Odds</label>
                    </div>
                </div>
                <button type="button" class="btn btn-outline-danger btn-sm rounded"
                    (click)="this.matchModel.tempArray=[];clearAll();closeSheet($event);">Cancel</button>
                <!-- <button fxFlex="30" mat-raised-button >Clear</button> -->
                <button type="button" class="btn btn-outline-success btn-sm rounded"
                    (click)="back.stake=0;back.p_l=0;">Clear</button>

            </div>
        </div>


    </div>
</div>